// 模板 16：企业内部知识管理与培训平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '企业知识与经验沉淀平台',
        content:
          '让组织中的经验与文档得到体系化管理与传承。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '在线培训与考试',
        content:
          '支持新员工入职培训与岗位能力认证。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '学习与知识数据中心',
      subtitle: '/ Knowledge & Learning Hub',
      paragraphs: [
        '通过对知识访问与学习行为的分析，帮助企业了解知识价值与使用情况。',
        '为人才发展与培训规划提供数据支撑。'
      ],
      buttonText: '预约平台演示'
    },
    contact: {
      title: '组织学习与知识管理助手',
      subTitle: '让知识真正服务于业务与员工成长',
      buttonText: '联系我们'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '知行云信息科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注为企业提供知识管理与在线培训平台，帮助组织搭建长期有效的知识体系。',
      '平台覆盖文档、课程与考试多个模块，适用于多种规模与行业的企业。'
    ]
  },
  news: [
    {
      id: 'KM01',
      title: '大型企业知识管理平台成功上线',
      introduce:
        '平台帮助客户整合分散在多个系统与个人电脑中的文档与资料。',
      date: '01-19',
      year: '2025'
    },
    {
      id: 'KM02',
      title: '发布在线培训新功能模块',
      introduce:
        '新增学习路径、考试与证书等功能，支持多岗位培训需求。',
      date: '08-30',
      year: '2024'
    },
    {
      id: 'KM03',
      title: '知识运营最佳实践手册上线',
      introduce:
        '总结不同行业客户的知识管理与运营经验，为新客户提供参考。',
      date: '04-06',
      year: '2024'
    },
    {
      id: 'KM04',
      title: '与多家咨询机构达成合作',
      introduce:
        '结合平台与咨询服务，为客户提供更完整的知识管理方案。',
      date: '10-11',
      year: '2023'
    },
    {
      id: 'KM05',
      title: '移动端知识小程序正式发布',
      introduce:
        '员工可以随时随地查阅知识与参与学习，提高使用频率。',
      date: '05-27',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '知识库与协作空间',
      sections: [
        {
          heading: '1. 结构化知识库',
          content:
            '支持以部门与主题构建多层级知识目录。'
        },
        {
          heading: '2. 文档编辑与协作',
          content:
            '多人协同编辑文档，记录版本与变更历史。'
        },
        {
          heading: '3. 权限与安全管理',
          content:
            '根据角色与项目设置知识访问权限，保障信息安全。'
        },
        {
          heading: '4. 搜索与推荐',
          content:
            '通过搜索与推荐功能，帮助员工快速找到需要的内容。'
        }
      ]
    },
    bigData: {
      title: '培训与学习管理系统',
      sections: [
        {
          heading: '1. 课程与学习计划',
          desc:
            '为不同岗位配置学习路线与课程组合。'
        },
        {
          heading: '2. 考试与测评',
          desc:
            '通过在线考试与测评了解员工学习效果。'
        },
        {
          heading: '3. 学习数据分析',
          desc:
            '统计学习完成率、考试通过率等关键指标。'
        },
        {
          heading: '4. 证书与合规记录',
          desc:
            '管理培训合规记录与证书信息，便于审计。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '知识管理体系咨询',
      engTitle: 'KM Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '平台实施与迁移',
      engTitle: 'Platform Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '知识运营辅导',
      engTitle: 'Knowledge Operations',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '培训项目共建',
      engTitle: 'Training Program',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '企业知识管理顾问',
    responsibilities: [
      '参与企业知识管理与培训项目咨询与落地；',
      '协助客户设计知识分类与运营机制；',
      '整理项目经验，形成可复制方法论。'
    ],
    requirements: [
      '有人力资源、培训或咨询相关经验优先；',
      '具备良好的沟通表达能力；',
      '对组织学习与知识管理有兴趣。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-16.js